import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Error(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Error", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 42c9.941 0 18-8.059 18-18S33.941 6 24 6 6 14.059 6 24s8.059 18 18 18Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 38.625c8.077 0 14.625-6.548 14.625-14.625S32.077 9.375 24 9.375 9.375 15.923 9.375 24 15.923 38.625 24 38.625Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        fill: theme.vars.palette.secondary.main,
        height: "13",
        rx: "1.5",
        transform: "rotate(-180 26 28)",
        width: "3",
        x: "26",
        y: "28"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: "24.5", cy: "31.5", fill: theme.vars.palette.secondary.main, r: "1.5", transform: "rotate(-180 24.5 31.5)" })
  ] });
}
Error.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Error"
};
validateTidalLicense();
export {
  Error
};
//# sourceMappingURL=Error.js.map
